import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
} from 'react-bootstrap';
import countries from 'country-calling-code';
var UsaStates = require('usa-states').UsaStates;
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import { splitName } from '../../utils';
import CoregPreviewModal from './CoregPreviewModal';

class CertificateRecipient extends Component {
  constructor(props) {
    super(props);

    this.state = {
      states: [],
      previewModalOpen: false,
    };
  }

  componentWillMount() {
    const usStates = new UsaStates();
    let { states } = usStates;
    states = [{ abbreviation: 'Non-U.S.' }, ...states];
    this.setState({ states });
  }

  componentWillReceiveProps(nextProps) {
    const { status } = nextProps;

    if (status !== this.props.status) {
      if (
        status === actionTypes.COREG_TEMP_CREATE_SUCCESS ||
        status === actionTypes.COREG_TEMP_CREATE_ERROR
      ) {
        if (status === actionTypes.COREG_TEMP_CREATE_ERROR) {
          this.props.alert(
            'error',
            'Oops! Coreg temp is not saved. Please try again. If this error persists, please contact us.'
          );
        }

        this.props.router.push('/copyright-reg/payment');
      }
    }
  }

  handleCheck(e, value) {
    const certificateChecked = e.target.checked ? true : false;

    let certificateRecipient = {};
    if (certificateChecked) {
      const { profile } = this.props;
      const names = splitName(profile.name);

      certificateRecipient = {
        firstName: names.firstName || '',
        lastName: names.lastName || '',
        email: profile.email || '',
        address: profile.address || '',
        city: profile.city || '',
        state: profile.state || '',
        zip: profile.postal || '',
        country: profile.country || '',
        tel: profile.tel || '',
      };
    } else {
      certificateRecipient = {
        firstName: '',
        lastName: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        tel: '',
      };
    }

    this.props.assignAttribute('certificateRecipient', {
      ...certificateRecipient,
    });
    this.props.assignAttribute('certificateChecked', certificateChecked);
  }

  handleText(e, key) {
    const { fields } = this.props;
    const certificateRecipient = fields.certificateRecipient || {};

    certificateRecipient[key] = e.target.value;
    this.props.assignAttribute('certificateRecipient', {
      ...certificateRecipient,
    });
  }

  createCoregTemp() {
    const { fields, profile } = this.props;

    const coreg = {
      user: profile.id,
      data: JSON.stringify(fields),
      is_success: false,
    };

    this.props.createCoregTemp(coreg);
  }

  checkStatus() {
    const { fields } = this.props;
    const certificateRecipient = fields.certificateRecipient || {};

    this.props.hideAlert();

    const keys = [
      'firstName',
      'lastName',
      'address',
      'city',
      'state',
      'zip',
      'country',
      'email',
    ];
    return keys.every((key) => certificateRecipient[key]);
  }

  handleNext() {
    const checked = this.checkStatus();

    if (!checked) {
      this.props.alert('error', 'Please check the required fields.');
    } else {
      // Save Coreg Temp before payment process
      this.setState({ previewModalOpen: false });
      this.createCoregTemp();
    }
  }

  previewTemp() {
    const checked = this.checkStatus();

    if (!checked) {
      this.props.alert('error', 'Please check the required fields.');
    } else {
      this.setState({ previewModalOpen: true });
    }
  }

  render() {
    const { fields } = this.props;
    const { states } = this.state;
    const certificateRecipient = fields.certificateRecipient || {};

    return (
      <div className="certificate-recipient">
        <Heading text="Where should your certificate be mailed to?" />
        <div className="content">
          <p>
            <span className="text-red">*</span>
            <b>Certificate Recipient</b>
          </p>
          <p>Where should we mail your certificate to?</p>
          <Form>
            <FormGroup>
              <Checkbox
                checked={
                  fields.certificateChecked ? fields.certificateChecked : false
                }
                onChange={(e) => this.handleCheck(e, false)}
              >
                Mail the certificate to me
              </Checkbox>
            </FormGroup>
            <div className="inner">
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>First Name:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={certificateRecipient.firstName || ''}
                  onChange={(e) => this.handleText(e, 'firstName')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">Middle Name: </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={certificateRecipient.middleName || ''}
                  onChange={(e) => this.handleText(e, 'middleName')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel>
                  <span className="text-red">*</span>Last Name:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={certificateRecipient.lastName || ''}
                  onChange={(e) => this.handleText(e, 'lastName')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">Organization: </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={certificateRecipient.organization || ''}
                  onChange={(e) => this.handleText(e, 'organization')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>Address:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={certificateRecipient.address || ''}
                  onChange={(e) => this.handleText(e, 'address')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>City:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={certificateRecipient.city || ''}
                  onChange={(e) => this.handleText(e, 'city')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>State:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  componentClass="select"
                  className="inline"
                  value={certificateRecipient.state || -1}
                  onChange={(e) => this.handleText(e, 'state')}
                >
                  <option disabled key={-1} value={-1}>
                    Select State
                  </option>
                  {states.map((item, i) => (
                    <option key={i} value={item.abbreviation}>
                      {item.abbreviation}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>Zip/Postal:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={certificateRecipient.zip || ''}
                  onChange={(e) => this.handleText(e, 'zip')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>Country:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  componentClass="select"
                  className="inline"
                  value={certificateRecipient.country || -1}
                  onChange={(e) => this.handleText(e, 'country')}
                >
                  <option disabled key={-1} value={-1}>
                    Select Country
                  </option>
                  {countries.map((country, i) => (
                    <option key={i} value={country.country}>
                      {country.country}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">Tel: </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={certificateRecipient.tel || ''}
                  onChange={(e) => this.handleText(e, 'tel')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>Email:{' '}
                </ControlLabel>
                <FormControl
                  type="email"
                  className="inline"
                  value={certificateRecipient.email || ''}
                  onChange={(e) => this.handleText(e, 'email')}
                />
              </FormGroup>
            </div>
          </Form>
        </div>
        <br />

        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          <div className="d-flex">
            <button className="btn-preview" onClick={() => this.previewTemp()}>
              Preview
            </button>
            {/* <NavButtons direction="next" next={() => this.handleNext()} /> */}
          </div>
        </div>

        <CoregPreviewModal
          show={this.state.previewModalOpen}
          fields={this.props.fields}
          workTypes={this.props.workTypes}
          subWorkTypes={this.props.subWorkTypes}
          hideModal={() => this.setState({ previewModalOpen: false })}
          moveNext={() => this.handleNext()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
  profile: state.profile,
  status: state.coreg.status,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypesCoreg,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
  createCoregTemp: (coreg) => {
    dispatch(actions.createCoregTemp(coreg));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CertificateRecipient);



// WEBPACK FOOTER //
// src/components/Copyright/CertificateRecipient.jsx